import {z} from 'zod';

export const OrganizationMemberStatusSchema = z.enum([
  'active',
  'pending',
  'deactivated',
  'expired',
]);
export type OrganizationMemberStatus = z.infer<typeof OrganizationMemberStatusSchema>;
